/**
 * Mock 试卷管理 API
 *
 * 提供 Mock 试卷的 CRUD 操作
 */

import httpRequest from '@/utils/api'
import type {
  Paper,
  UpdatePaperRequest,
  PaperListResponseData,
} from '@/types/mock/paper'

enum API {
  papers = '/mock-api/admin/papers',
  updatePaper = '/mock-api/admin/papers/:paperId',
}

/**
 * 获取所有试卷
 *
 * @param categoryId 分类 ID（可选）
 * @returns 试卷列表响应
 */
export const getAllPapersAPI = (categoryId?: number) => {
  return httpRequest.get<PaperListResponseData>({
    url: API.papers,
    params: {
      ...(categoryId ? { category_id: categoryId } : {}),
    },
  })
}

/**
 * 更新试卷信息
 *
 * @param paperId 试卷 ID
 * @param data 更新请求数据
 * @returns 试卷详情响应
 */
export const updatePaperAPI = (
  paperId: number,
  data: UpdatePaperRequest
) => {
  return httpRequest.patch<Paper>({
    url: API.updatePaper.replace(':paperId', paperId.toString()),
    data,
  })
}
